import Vue from 'vue';
import Vuex from 'vuex';
import yearNav from './modules/yearNav';

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
    modules: {
        yearNav,
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js